"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendgridTemplatePartialToJSON = exports.SendgridTemplatePartialFromJSONTyped = exports.SendgridTemplatePartialFromJSON = void 0;
function SendgridTemplatePartialFromJSON(json) {
    return SendgridTemplatePartialFromJSONTyped(json, false);
}
exports.SendgridTemplatePartialFromJSON = SendgridTemplatePartialFromJSON;
function SendgridTemplatePartialFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'updated_at': json['updated_at'],
    };
}
exports.SendgridTemplatePartialFromJSONTyped = SendgridTemplatePartialFromJSONTyped;
function SendgridTemplatePartialToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'updated_at': value.updated_at,
    };
}
exports.SendgridTemplatePartialToJSON = SendgridTemplatePartialToJSON;
